export const BASE_DATA_API_URL = import.meta.env.VITE_BASE_DATA_API_URL;
export const BASE_ADMIN_API_URL = import.meta.env.VITE_BASE_ADMIN_API_URL;
export const BASE_REGISTRATION_API_URL = import.meta.env.VITE_BASE_REGISTRATION_API_URL;
export const ANTHROPIC_API_KEY = import.meta.env.VITE_ANTHROPIC_API_KEY;
